/*
##############
## CheckBox ##
##############
Modal box to show messages. This use jQuery/Bootstrap Modal. Implemented with http://react-bootstrap.github.io/components.html#modals

* OPTIONS
   * bsSize[String]: Width of page. "small", "large". Default: medium. Optional.
   * mainAction[Function]: Is executed when the button of type main action (for example "Accept") is clicked.
   * closeButton [Boolean]: Show the button to close the window. Default: false.
   * closeIcon [Boolean]: Show the icon to close the window. Default: true.
   * defaultOpen [Boolean]: Automatic show modal. Default: false. Optional.
   * openButton [Boolean]: Show the open button. Default is TRUE. Optional.
   * textButton [String]: Text for the button that open the modal. Default: Open. Optional.
   * textButtonClose[String]: Text for close's button.
   * textButtonMainAction[String]: Text for main action's button.
   * classNameMainButton[String]: Class for the main action's button. Optional.
   * width[Number]: Width of the modal. Not required.

* EXAMPLE
   <ModalBox
       bsSize="large"
       defaultOpen={true}
   >
   <p>Hello, it is me you're looking for.</p>
   </ModalBox>

*/
require('../../styles/blocks/_modal.scss');
require('../../styles/blocks/_blowup-modal.scss');

const React = require('react');
const PropTypes = require('prop-types');

const Modal = require('react-bootstrap/lib/Modal');
import { formatText } from 'core/i18n';

class ModalBox extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
            blowupClass: 'blowup-modal blowup-in',
        };

        this.handleOnOpen = this.handleOnOpen.bind(this);
        this.handleOnClose = this.handleOnClose.bind(this);
        this.handleOnAccept = this.handleOnAccept.bind(this);
        this.handleBlowupClass = this.handleBlowupClass.bind(this);
        this.handleOnEntered = this.handleOnEntered.bind(this);
    }

    componentDidMount() {
        const { defaultOpen } = this.props;
        if (defaultOpen) {
            this.handleOnOpen();
        }
    }

    handleOnOpen() {
        this.setState({
            showModal: true,
            blowupClass: 'blowup-modal blowup-in',
        });
    }

    handleBlowupClass() {
        this.setState({ blowupClass: 'blowup-modal blowup-out' });
        setTimeout(() => {
            this.handleOnClose();
        }, 200);
    }

    handleOnClose() {
        this.setState({
            showModal: false,
        });
    }

    handleOnAccept() {
        const { mainAction } = this.props;
        if (mainAction) {
            mainAction();
        }
        this.handleBlowupClass();
    }

    handleOnEntered() {
        const { anchorNro } = this.props;
        if (anchorNro) {
            const anchor = document.getElementsByName(anchorNro);
            anchor[0].scrollIntoView();
        }
    }

    render() {
        const {
            bsSize,
            closeButton,
            closeIcon,
            textButton,
            className,
            modalTitle,
            modalLogo,
            openButton,
            textButtonClose,
            textButtonMainAction,
            classNameMainButton,
            width,
            type,
        } = this.props;
        let props = [];
        let showCloseIcon = closeIcon ? (
            <div className="close-icon">
                <a
                    href="#"
                    onClick={event => {
                        event.preventDefault();
                        this.handleBlowupClass();
                    }}
                >
                    <span className="icons--icon-cancel"></span>
                </a>
            </div>
        ) : (
            ''
        );
        let showCloseButton = closeButton ? (
            <button className="close-button" onClick={this.handleBlowupClass}>
                {textButtonClose}
            </button>
        ) : (
            ''
        );
        let showOpenButton = openButton ? (
            <a
                href="#"
                onClick={event => {
                    event.preventDefault();
                    this.handleOnOpen();
                }}
            >
                <i className={className}>{textButton}</i>
            </a>
        ) : (
            ''
        );

        let modalWidth;
        if (width !== 0) {
            modalWidth = 'w' + width;
        }

        if (bsSize) {
            props['bsSize'] = bsSize;
        }

        return (
            <span>
                {showOpenButton}
                <Modal
                    show={this.state.showModal}
                    onHide={this.handleBlowupClass}
                    onEntered={this.handleOnEntered}
                    dialogClassName={`ob-custom-modal ${modalWidth} ${this.state.blowupClass} ${type}`}
                    backdrop={'static'}
                    animation={true}
                    {...props}
                >
                    <Modal.Header>
                        {showCloseIcon}
                        <div className={`title ${type}-title`}>
                            {modalLogo}
                            <h5>{modalTitle}</h5>
                        </div>
                    </Modal.Header>
                    <Modal.Body>{this.props.children}</Modal.Body>
                    <Modal.Footer>
                        <div className={`options-area ${type}-footer`}>
                            {showCloseButton}
                            <button
                                className={`form__button ${classNameMainButton} ${type}-footer-main-button`}
                                onClick={this.handleOnAccept}
                            >
                                {textButtonMainAction}
                            </button>
                        </div>
                        <div className="clearfix"></div>
                    </Modal.Footer>
                </Modal>
            </span>
        );
    }
}

ModalBox.propTypes = {
    bsSize: PropTypes.string,
    closeButton: PropTypes.bool,
    closeIcon: PropTypes.bool,
    textButton: PropTypes.string,
    className: PropTypes.string,
    mainAction: PropTypes.func,
    modalTitle: PropTypes.string,
    modalLogo: PropTypes.element,
    defaultOpen: PropTypes.bool,
    openButton: PropTypes.bool,
    textButtonClose: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]),
    textButtonMainAction: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.element]),
    classNameMainButton: PropTypes.string,
    width: PropTypes.number,
    anchorNro: PropTypes.string,
    type: PropTypes.string,
};

ModalBox.defaultProps = {
    closeButton: true,
    closeIcon: true,
    textButton: formatText('button-open'),
    className: 'form__button form__button-primary',
    modalTitle: '',
    defaultOpen: false,
    openButton: true,
    textButtonClose: formatText('button-close'),
    textButtonMainAction: formatText('button-accept'),
    classNameMainButton: 'form__button-secondary',
    width: 0,
    anchorNro: '',
    type: '',
};

module.exports = ModalBox;
